import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService extends AbstractService {
  protected override prefix = '/captcha';

  submitAnswer(id: number, answer: string, errorCallback: Function): Observable<void> {
    return this.post(
      `/${ id }/answer`,
      { answer },
      {
        throwError: true,
        errorCallback
      }
    );
  }
}